import cn from 'classnames';
import styles from './ReviewsAndQuestions.module.scss';
import { fetchData } from '@/services';
import { TabSwitcher } from '@/atoms/TabSwitcher';
import { ReviewsBlock } from '../ReviewsBlock';
import { QuestionsBlock } from '../QuestionsBlock';
import { ProductDetailedType } from '@/types';

type ReviewsAndQuestionsProps = {
  className?: string;
  product: ProductDetailedType;
};

export async function ReviewsAndQuestions({
  className,
  product,
}: ReviewsAndQuestionsProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  const reviews = await fetchData({
    url: `/form/review/list?productId=${product.id}`,
  });

  const questions = await fetchData({
    url: `/form/faq/list?productId=${product.id}`,
  });

  if (!reviews.success || !questions.success) return null;

  const screenTabData = [
    {
      id: 'reviews',
      title: 'Отзывы',
      content: <ReviewsBlock items={reviews.data.list} product={product} />,
      count: reviews.data.list.length,
    },
    {
      id: 'questions',
      title: 'Вопросы',
      content: <QuestionsBlock items={questions.data.list} product={product} />,
      count: questions.data.list.length,
    },
  ];

  return (
    <div className={wrapperClassName} id="reviews">
      <TabSwitcher tabs={screenTabData} />
    </div>
  );
}
